import { createFileRoute } from '@tanstack/react-router';
import { PomodoroPage } from '../../components/pomodoro/PomodoroPage';

export const Route = createFileRoute('/tasks/pomodoro')({
  component: PomodoroPage,
});
